export const ACCOUNT_TYPE = {
  STANDARD: 'STANDARD',
  MARKETING: 'MARKETING',
};
